import React, { useEffect, useState, useRef } from "react";
import {

  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,

  Row,
} from "reactstrap";
import ChevronDown from "../chevron/ChevronDown";
import ChevronUp from "../chevron/ChevronUp";
import manageSubTeam from "../apis/manageSubTeam";


function EditSubTeamModal({
  edit_sub_team_modal,
  set_edit_sub_team_modal,
  currentUser,
  DummyAvatarSvg,
  set_remove_sub_team_modal,

}) {
  const [sub_team_name, set_sub_team_name] = useState("");
  const [admin_dropdown, set_admin_dropdown] = useState(false);
  const [manage_dropdown, setManage_dropdown] = useState(false);



  const [admin_dropdown_value, set_admin_dropdown_value] = useState(null);
  const [updatedManageDropdowArray, setUpdatedManageDropdowArray] = useState(
    []
  );

  const [manage_dropdown_value, setManage_dropdown_value] = useState([]);
  const [tableData, setTableData] = useState([]);

  const [members, setMembers] = useState([]);


  const manageDropdownRef = useRef(null);

  useEffect(() => {
      set_sub_team_name(edit_sub_team_modal?.sub_name);
      set_admin_dropdown_value(edit_sub_team_modal?.admin);
      setTableData(edit_sub_team_modal?.members || []);
      setManage_dropdown_value(edit_sub_team_modal?.members || []);
  },[] );
  


  const check_disabled = () => {
    if (
      sub_team_name == edit_sub_team_modal?.sub_name &&
      admin_dropdown_value?.user_id == edit_sub_team_modal?.admin?.user_id &&
      !manage_dropdown_value
    ) {
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    const userIds = tableData.map((user) => {
      return user?.user_id;
    });
    setMembers(userIds);
  }, [tableData]);
  useEffect(() => {
    const handleClickOutsideManage = (event) => {
      if (
        manageDropdownRef.current &&
        !manageDropdownRef.current.contains(event.target)
      ) {
        setManage_dropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutsideManage);

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideManage);
    };
  }, []);
  const handleChangeInviteTeammates = (user) => {
    const updatedManageDropdowArrayCopy = [...manage_dropdown_value];

    const userIndex = updatedManageDropdowArrayCopy.findIndex(
      (player) => player.Username === user.Username
    );
console.log(userIndex , "userIndex===>>");
    if (userIndex !== -1) {
      updatedManageDropdowArrayCopy.splice(userIndex, 1);
    } else {
      updatedManageDropdowArrayCopy.push(user);
    }

    setManage_dropdown_value(updatedManageDropdowArrayCopy);

    setUpdatedManageDropdowArray(updatedManageDropdowArrayCopy);

  };

 


  const handleCheckBoxInviteTeammates = (user) => {
    const isUserInList = manage_dropdown_value.some(
      (player) => player.Username === user.Username
    );
    console.log(isUserInList , "isUserInListisUserInList");
    return isUserInList;
  };







  const handleSaveButtonClick = () => {
    setTableData([...manage_dropdown_value]);
  };

  return (
    <>
      {/* <Modal
        centered
        isOpen={!!edit_sub_team_modal}
        toggle={() => set_edit_sub_team_modal(null)}
        className="team-modal"
      >
        <ModalHeader toggle={() => set_edit_sub_team_modal(null)}>
          Edit Sub-Team
        </ModalHeader>
        <p className="text">Edit your sub-team name and admin.</p>
        <ModalBody>
          <div className="mb-3">
            <Input
              type="text"
              name="team_name"
              className="input-field"
              placeholder="Enter Team Name"
              value={sub_team_name}
              onChange={(e) => set_sub_team_name(e.target.value)}
            />
          </div>

          <div className="team-dropdown">
            <Dropdown
              isOpen={admin_dropdown}
              toggle={() => {
                set_admin_dropdown(!admin_dropdown);
              }}
              value={admin_dropdown_value?.name}
            >
              <DropdownToggle>
                <h3>
                  {admin_dropdown_value
                    ? admin_dropdown_value?.name
                    : "Select Admin"}
                </h3>
                {admin_dropdown ? (
                  <ChevronDown color="#18154D" />
                ) : (
                  <ChevronUp color="#18154D" />
                )}
              </DropdownToggle>
              <DropdownMenu>
                {currentUser.team.users.map((user) => (
                  <DropdownItem onClick={() => set_admin_dropdown_value(user)}>
                    <Input
                      type="radio"
                      name="tname"
                      className="mr-3"
                      checked={
                        (user?.Username || user?.user_id) ==
                        admin_dropdown_value?.user_id
                      }
                    />
                    {user?.picture ? (
                      <img
                        src={user?.picture || DummyAvatarSvg}
                        className="profile-pic"
                        alt=""
                      />
                    ) : (
                      <DummyAvatarSvg className="avatar" />
                    )}
                    <p className="name">{user?.name}</p>
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-5">
            <button
              className="cancel-btn"
              onClick={() => set_edit_sub_team_modal(null)}
            >
              Cancel
            </button>
            <button
              className={`save-btn ${check_disabled() ? "disabled" : ""}`}
              disabled={check_disabled()}
              onClick={async () => {
                await editSubTeam({
                  team_code: currentUser.team.id,
                  old_sub_name: edit_sub_team_modal?.sub_name,
                  new_sub_name: sub_team_name,
                  user_id: admin_dropdown_value?.user_id,
                });
                set_edit_sub_team_modal(null);
              }}
            >
              Save
            </button>
          </div>
        </ModalBody>
      </Modal> */}

      <div>
        <Container>
          <section className="team-details">
            <div className="mb-4">
              <h4 className="text">Team Details</h4>
              <p className="desc">Add team name, admin and teammates</p>
              <input
                type="text"
                className="teamName"
                name="teamName"
                placeholder="Enter Sub-Team Name"
                value={sub_team_name}
                onChange={(e) => set_sub_team_name(e.target.value)}
              />
            </div>
            <label htmlFor="">Select Admin</label>

            <div className="team-dropdown">
              <Dropdown
                isOpen={admin_dropdown}
                toggle={() => {
                  set_admin_dropdown(!admin_dropdown);
                }}
                value={admin_dropdown_value?.name}
              >
                <DropdownToggle>
                  <h3>
                    {admin_dropdown_value
                      ? admin_dropdown_value?.name
                      : "Select Admin"}
                  </h3>
                  {admin_dropdown ? (
                    <ChevronDown color="#18154D" />
                  ) : (
                    <ChevronUp color="#18154D" />
                  )}
                </DropdownToggle>
                <DropdownMenu>
                  {currentUser.team.users.map((user) => (
                    <DropdownItem
                      onClick={() => set_admin_dropdown_value(user)}
                    >
                      <Input
                        type="radio"
                        name="tname"
                        className="mr-3"
                        checked={
                          (user?.Username || user?.user_id) ==
                          admin_dropdown_value?.user_id
                        }
                      />
                      {user?.picture ? (
                        <img
                          src={user?.picture || DummyAvatarSvg}
                          className="profile-pic"
                          alt=""
                        />
                      ) : (
                        <DummyAvatarSvg className="avatar" />
                      )}
                      <p className="name">{user?.name}</p>
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </div>
         


            <section className="manage-t-mates">
              <div className="mb-4">
                <h4 className="text">Manage Teammate(s)</h4>
                <p className="desc">
                  Select one or more teams to add to your Team.{" "}
                </p>
              </div>
              <div className="d-flex justify-content-between">
                <div className="team-dropdown" ref={manageDropdownRef}>
                  <Dropdown
                    isOpen={manage_dropdown}
                    value={manage_dropdown_value}
                    toggle={() => {
                      setManage_dropdown(true);
                    }}
                    // direction={direction}
                  >
                    <DropdownToggle>
                      <h3>
                        {tableData ? tableData?.name : "No Team Selected"}
                        <p className="mb-0">
                          {tableData.length > 0
                            ? tableData[0]?.name +
                              "," +
                              "+" +
                              (tableData.length - 1) +
                              "More"
                            : "Teammate Name"}
                        </p>
                      </h3>
                      {manage_dropdown ? (
                        <ChevronDown color="#18154D" />
                      ) : (
                        <ChevronUp color="#18154D" />
                      )}
                    </DropdownToggle>
                    <DropdownMenu>
                      {currentUser.team.users.map((user) => (
                        
                        
                        <DropdownItem
                          onClick={() => handleChangeInviteTeammates(user)}
                        >
                          <Input
                            type="checkbox"
                            name="tname"
                            className="mr-3"
                            // checked={updatedManageDropdowArray.find((player) => 
                            //  player.Username === user.Username)}
                            checked = {handleCheckBoxInviteTeammates(user)}
                            
                          />

                          {user?.picture ? (
                            <img
                              src={user?.picture}
                              className="profile-pic"
                              alt=""
                              z
                            />
                          ) : (
                            <DummyAvatarSvg className="avatar" />
                          )}
                          <p className="name">{user?.name}</p>
                        </DropdownItem>
                            ))}
                    </DropdownMenu>
                  </Dropdown>
                </div>

                <button
                  className="save-btn"
                  onClick={() => handleSaveButtonClick()}
                >
                  Save
                </button>
              </div>
            </section>
          </section>
        </Container>

        <Container>
          <div className="teamone-data-wrapper">
            <div className="team-data">
              <div className="header-col">
                <h4>Teammate</h4>
              </div>
              <div className="header-col">
                <h4>Email</h4>
              </div>
              <div className="header-col">
                <h4>Sub Team</h4>
              </div>
              {/* <div className="header-col-dots">
                <h4></h4>
              </div> */}
            </div>
            {/* {users?.map((user) => (
              <> */}
            {tableData?.map((user) => (
              <>
                <div className="team-data">
                  <div className="column teammate-col">
                    {/* <DummyAvatarSvg className="avatar" /> */}

                    {/* {user.picture ? (
                      <img src={user.picture} alt="" />
                    ) : (
                      <DummyAvatarSvg className="avatar" />
                    )} */}

                    <p className="mb-0">{user.name}</p>
                  </div>
                  <div className="column email-col">
                    <p className="txt mb-0">{user.email}</p>
                  </div>
                  <div className="column email-col">
                    <p className="txt mb-0">{user.sub_team}</p>
                  </div>
                  {/* <div className="team-col-flex"> */}
                </div>
                {/* </div> */}
                {/* <div
                  className="text-center w-100 three-dots"
                  style={{ visibility: "hidden" }}
                >
                  <img src={threeDotsIcon} alt="" />
                  <div className="tooltip-content">
                    <ul>
                      <li>Edit</li>
                      <li>Remove</li>
                    </ul>
                  </div>
                </div> */}
              </>
            ))}
            {/* </>
            ))} */}
          </div>
          {/* <section className="not-found">
            <h4>Teammates</h4>
            <div className="no-tm-found">
              <img src={noTeammatesImg} alt="" />
              <p className="text">
                No teammates to display. Add teammates to participate in your
                challenge.
              </p>
            </div>
          </section> */}
        </Container>
        <section className="team-details-fixed">
          <Container>
            <Row>
              <Col md={7}>
                <h2>Add Team Details</h2>
              </Col>
              <Col md={5} className="text-right">
                <div className="button-wraper">
                  <button
                    onClick={() => set_edit_sub_team_modal(null)}
                    className="back-btn-edit-subteam"
                  >
                    Back
                  </button>

                  <button
                    onClick={() => {
                      set_remove_sub_team_modal(edit_sub_team_modal);
                    }}
                    className="del-btn"
                  >
                    Delete
                  </button>
                  <button
                    disabled={check_disabled()}
                    onClick={async () => {
                      await manageSubTeam({
                        team_code: currentUser.team.id,
                        sub_name: edit_sub_team_modal?.sub_name,
                        new_sub_name: sub_team_name,
                        // sub_name: sub_team_name,

                        admin: admin_dropdown_value?.user_id,
                        user_ids: members,
                      });

                      set_edit_sub_team_modal(null);
                    }}
                    className="save-btn"
                  >
                    Save
                  </button>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
}

export default EditSubTeamModal;
